export class Time {
    constructor(base, version) {
        this.base = base;
        this.version = version;
        this.withMigrationTime = async (version, run) => {
            this.overrideNow = () => {
                return this.base.zero(version);
            };
            await run();
            this.overrideNow = undefined;
        };
        this.update = this.base.update.bind(this.base);
        this.nowWithVersion = (version) => {
            return this.base.now(version);
        };
        this.zeroWithVersion = (version) => {
            return this.base.zero(version);
        };
    }
    get now() {
        return this.overrideNow ? this.overrideNow() : this.base.now(this.version);
    }
    get zero() {
        return this.base.zero(this.version);
    }
}
//# sourceMappingURL=Time.js.map